module.exports = __webpack_public_path__ + "img/goods8_1.aeb48732.jpg";